import { render, staticRenderFns } from "./RequestForgotPassword.vue?vue&type=template&id=5c3265a8&scoped=true&lang=true"
import script from "./RequestForgotPassword.vue?vue&type=script&lang=js"
export * from "./RequestForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./RequestForgotPassword.vue?vue&type=style&index=0&id=5c3265a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3265a8",
  null
  
)

export default component.exports